module.exports = __webpack_public_path__ + "static/media/template_5_default_cover~ZejPSuPx.e7f34960.png";